export const lightPalette = {
  background: {
    default: "#504C49",
    paper: "#494541",
    inputField: "#5E5855",
    dropdown: "#383633",
  },
};
